import React from 'react';

import { SpeechButton } from 'components/atoms/speech';
import { SpeechPlaybackControl } from 'hooks/useSpeech';

interface BiddingSummaryDrawerHeaderProps {
  titleId: string;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  getSpeechText: () => string;
  onClose: () => void;
  onChatClick: () => void;
  isChatOpen?: boolean;
  iaIconSrc: string;
  speechPlayback: SpeechPlaybackControl;
}

const BiddingSummaryDrawerHeader: React.FC<BiddingSummaryDrawerHeaderProps> = ({
  titleId,
  title,
  subtitle,
  getSpeechText,
  onClose,
  onChatClick,
  isChatOpen = false,
  iaIconSrc,
  speechPlayback,
}) => (
  <div className="modal-header bidding-summary-modal-header d-flex align-items-center flex-shrink-0">
    <div className="bidding-summary-header-inner d-flex align-items-center justify-content-between w-100 flex-wrap flex-md-nowrap">
      <div className="bidding-summary-header-text mr-auto pr-3 mb-2 mb-md-0">
        <h4 id={titleId} className="bidding-summary-drawer-title mb-0">
          {title}
        </h4>
        <div className="bidding-summary-drawer-subtitle">{subtitle}</div>
      </div>

      <div className="bidding-summary-header-toolbar">
        <div className="bidding-summary-header-actions">
          <SpeechButton
            variant="modalOutline"
            idleIcon="volume_up"
            getText={getSpeechText}
            speechPlayback={speechPlayback}
          />
          <button
            type="button"
            className={`btn bidding-summary-header-action-btn ${
              isChatOpen ? 'bidding-summary-header-action-btn--active' : ''
            }`}
            onClick={onChatClick}
            aria-pressed={isChatOpen}
          >
            <span className="bidding-summary-header-action-ia-wrap" aria-hidden="true">
              <img alt="" src={iaIconSrc} />
            </span>
            <span className="bidding-summary-header-action-btn-label">Pergunte ao Edital</span>
          </button>
        </div>
        <button
          type="button"
          aria-label="Fechar"
          className="close bidding-summary-header-close bg-transparent border-0"
          onClick={onClose}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
    </div>
  </div>
);

export default BiddingSummaryDrawerHeader;
